


import {SystemDataVM} from './SystemDataVM';
export class CounsellingTopicVM extends SystemDataVM {
    
}
